import type {
  DeliveryPriceRequest,
  DeliveryPricing,
  LiftPricing,
  OrderRequest,
  PickupDeliveryData,
} from '@/js/types/order.ts';
import { makeApiRoute, makeLocalizedStoreApiRoute, makeRequest } from '@/js/api/request-service.ts';

export async function createOrder(data: OrderRequest) {
  return makeRequest<{
    success: boolean
    id: number | null
    payment_url: string | null
  }>({
    method: 'POST',
    url: makeLocalizedStoreApiRoute('orders'),
    data,
  });
}

export async function getDeliveryData() {
  return makeRequest<DeliveryPricing>({
    method: 'GET',
    url: makeApiRoute('delivery/self/data'),
  });
}

export async function getPickupData() {
  return makeRequest<PickupDeliveryData>({
    method: 'GET',
    url: makeApiRoute('delivery/pickup/data'),
  });
}

export async function getLiftData() {
  return makeRequest<LiftPricing>({
    method: 'GET',
    url: makeApiRoute('lift/data'),
  });
}

export async function getDeliveryPrice(data: DeliveryPriceRequest) {
  return makeRequest({
    method: 'POST',
    url: makeLocalizedStoreApiRoute('orders/delivery/get-price'),
    data,
  });
}

export async function getSuggestAddress(query: string) {
  return makeRequest({
    method: 'POST',
    url: makeApiRoute('orders/delivery/address/suggest'),
    data: {
      query,
    },
  });
}
